import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=aa8dc952&"
import script from "./EditBatch.vue?vue&type=script&lang=js&"
export * from "./EditBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports